module.exports = __webpack_public_path__ + "static/img/1.e033dc8.png";


//////////////////
// WEBPACK FOOTER
// ./static/1.png
// module id = tugK
// module chunks = 1